module.exports = __webpack_public_path__ + "static/media/login-header.9b7e12cd.svg";